import { secretStorage } from "config";
import { application } from "store/hooks";

const useSetUserData = () => {
    const setAppData = application.useInitAppData()

    return (user) => {
        secretStorage.setItem("user", user)
        document.cookie = "user_exist=true; max-age=" + 7 * 60 * 60; //7 שעות
        setAppData(user)
    }
}

export default useSetUserData